<template>
  <div class="db-block clearBoth">
    <g-switch-list2
      class="switch-wrap"
      v-for="(innerList, index) in data.vertical"
      :key="'iL' + index"
      :list="innerList.list"
      :title="innerList.title"
      :chip="chip"
      :verticalType="2"></g-switch-list2>
  </div>
</template>

<script>
  import mixin from '../mixins';
  import GSwitchList2 from '../../c_game-switch/switch-list/g_switch-1'; // 纵向

  export default {
    name: "dh1-10",
    mixins: [mixin],
    components: {GSwitchList2},
  }
</script>

<style scoped lang="stylus">
  .db-block
    width 100%
    font-size 12px

    .switch-wrap
      width calc(20% - 5.6px)
      float left
      margin-top 7px

    > .switch-wrap + .switch-wrap
      margin-left 7px

    > .switch-wrap:nth-of-type(6)
      margin-left 0px
</style>



// WEBPACK FOOTER //
// src/components/pageComponents/lh/dh1-10.vue